import styled from "styled-components";

export const StyledButton = styled.button`
    background-color: inherit;
    border: none;
    padding: 0;
    &:hover {
        background-color: inherit;
        border: none;
        box-shadow: none;
        outline: none;
        cursor: ${(props) => (props.disable ? "not-allowed" : "pointer")};
    }
    &:active {
        background-color: ${globalThis.config.colors.orange1};
        border: none;
        box-shadow: none;
        outline: none;
    }
    &:focus {
        background-color: inherit;
        border: none;
        box-shadow: none;
        outline: none;
        outline: none;
    }
`;
